import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BsGrid3X3GapFill, BsListStars } from 'react-icons/bs';
import { FaMapMarkedAlt } from 'react-icons/fa';
import { IoBookmarkOutline } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import BannerImageAd from '../../Component/BannerImageAd';
import BreadCrumb from '../../Component/BreadCrumb';
import Button from '../../Component/Button/Button';
import BuyRentCommercialFilters from '../../Component/BuyRentCommercialFilters';
import DropDown from '../../Component/DropDown/DropDown';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import { Loader } from '../../Component/Loader';
import NoData from '../../Component/NoData/NoData';
import { PaginationComponent } from '../../Component/Pagination/Pagination';
import PropertyCard from '../../Component/PropertyCard';
import PropertyHorizontalCard from '../../Component/PropertyHorizontalCard/PropertyHorizontalCard';
import Tabs from '../../Component/Tabs';
import Tooltip from '../../Component/Tooltip';
import MapMain from '../../Component/maps/MapMain';
import { isMobileViewHook } from '../../CustomHooks/isMobileViewHook';
import { restrictOnlyUserActions } from '../../Helper/restrictActions';
import {
  buyLangObj,
  inTurkeyLangObj,
  propertyLangObj,
  rentLangObj,
  residentialLangObj
} from '../../config/DummyData';
import {
  capitalizeFirstLetter,
  discardUndefinedOrNullValues,
  imageUrl,
  recordsLimit15
} from '../../config/apiUrl';
import {
  bathRoomsFilterOptions,
  floorLevelFilterOptions,
  furnitureFiltersOptions,
  parkingSpaceFilterOptions,
  propertyAgeFilterOptions,
  propertyFilterOptions,
  propertyPurposeOptions,
  propertyStatusFilterOptions,
  rentTypes,
  roomFilterOptions
} from '../../constant/commonData';
import EmailAgentModal from '../../modals/EmailAgentModal';
import SaveSearchModal from '../../modals/SaveSearchModal/SaveSearchModal';
import { useGetPublicPropertiesMutation, usePostApiMutation } from '../../store/apiSlice/apiSlice';
import {
  bannerConditions,
  convertAreaIfNotInMeterSqaure,
  generateBanners,
  getValue,
  otherToUsd
} from '../../utils/helpers';
import classes from './properties.module.css';

function Properties({ purpose = null }) {
  const isSavedFilter = useLocation()?.state;
  const routeName = useLocation()?.pathname?.split('/')[1];
  const { allBanners, interiorAmenities, exteriorAmenities } = useSelector(
    (state) => state.commonReducer
  );
  const { areaUnit, currency } = useSelector((state) => state.converterReducer);

  const verticalBanners = allBanners?.filter(
    (item) => item?.page === routeName && item?.bannerType == 'vertical'
  );

  const { t } = useTranslation('buyRentProperties');
  const [isSticky, setIsSticky] = useState(false);
  const pathname = useLocation()?.pathname?.split('/')[1];
  const [isMobile, setIsMobile] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState('');
  const { isLogin, user } = useSelector((state) => state.authReducer);
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const [selectedItem, setSelectedItem] = useState(null);
  const [page, setPage] = useState(1);
  const [showSaveSearch, setShowSaveSearch] = useState(false);
  const [saveSearchLoading, setSaveSearchLoading] = useState(false);

  const horizontalBanners = generateBanners({
    allBanners,
    routeName,
    page
  });

  const [filters, setFilters] = useState({
    rentType: [],
    propertyPurpose: purpose,
    maxArea: null,
    minArea: null,
    propertyAge: null,
    parkingSpace: null,
    noOfRooms: null,
    noOfBathrooms: null,
    floorLevel: null,
    propertyStatus: null,
    minPrice: null,
    maxPrice: null,
    furniture: null,
    nearby: false,
    country: null,
    lng: null,
    lat: null,
    lan: selectedLanguage,
    province: null,
    neighborhood: null,
    town: null,
    interiorAmenities: [],
    exteriorAmenities: [],
    entity: null,
    date: '',
    sortBy: null, // Add sortBy here
    sortType: null,
    propertyClassification: residentialLangObj,
    propertyText: propertyLangObj,
    inTurkeyLangObj: inTurkeyLangObj,
    address: ''
  });

  const [postApiFunc] = usePostApiMutation();

  // floorLevel: floorLevel,
  // parkingSpace: parkingSpace,
  // furniture: isFurniture,
  // propertyAge: propertyAge,
  // interiorAmenities: selectedInteriorAmenities,
  // exteriorAmenities: selectedExteriorAmenities
  const [searchText, setSearchText] = useState('');
  const [getProperties, { isLoading, data }] = useGetPublicPropertiesMutation();
  const [mapProperties, setMapProperties] = useState(data?.data ?? []);

  useEffect(() => {
    if (data?.data) {
      setMapProperties(data?.data);
    }
  }, [data]);

  const filtersToSearchParams = (fil) => {
    const params = new URLSearchParams();

    ['province', 'town', 'neighborhood'].forEach((key) => {
      const value = filters?.[key] ?? isSavedFilter?.[key];
      if (value !== null && value !== undefined && value !== '') {
        if (typeof value === 'object') {
          params.set(key, JSON.stringify(value));
        } else {
          params.set(key, value);
        }
      }
    });

    Object.entries(fil).forEach(([key, value]) => {
      if (['province', 'town', 'neighborhood'].includes(key)) return; // skip these, already set
      if (value === null || value === undefined || value === '') return;
      if (Array.isArray(value)) {
        const isObjectArray = value.some((item) => typeof item === 'object');
        if (isObjectArray) {
          params.set(key, JSON.stringify(value));
        } else {
          params.set(key, value.join(','));
        }
      } else if (typeof value === 'object') {
        params.set(key, JSON.stringify(value));
      } else {
        params.set(key, value);
      }
    });

    return params;
  };

  const searchParamsToFilters = (params) => {
    const filters = {};

    for (const [key, value] of params.entries()) {
      try {
        const parsed = JSON.parse(value);
        filters[key] = parsed;
      } catch {
        if (value.includes(',')) {
          filters[key] = value.split(',').map((v) => {
            try {
              return JSON.parse(v);
            } catch {
              return v;
            }
          });
        } else {
          filters[key] = value;
        }
      }
    }

    return filters;
  };

  const handleGetProperties = async (fil = getFilterModifyData(filters), pg = page) => {
    // if fil.address not break in , seprated values AND SEND STRING IN   window.history.replaceState({}, '', `?${searchParams.toString()}`);

    if (fil.address && Array.isArray(fil.address)) {
      // If address is an array, join it into a single string
      fil = { ...fil, address: fil.address.join(',') };
    }

    // Fix only province, town, neighborhood: send _id if object
    const apiFil = {
      ...fil,
      ...(fil?.province
        ? {
            province:
              typeof fil?.province === 'object' && fil?.province?._id
                ? fil?.province?._id
                : fil?.province
          }
        : {}),
      ...(fil?.town
        ? {
            town: typeof fil?.town === 'object' && fil?.town?._id ? fil?.town?._id : fil?.town
          }
        : {}),
      ...(fil?.neighborhood
        ? {
            neighborhood:
              typeof fil?.neighborhood === 'object' && fil?.neighborhood?._id
                ? fil?.neighborhood?._id
                : fil?.neighborhood
          }
        : {})
    };

    const searchParams = filtersToSearchParams(fil);
    window.history.replaceState({}, '', `?${searchParams.toString()}`);

    // 2. Call API
    await getProperties({
      page: pg,
      limit: recordsLimit15,
      data: {
        lan: selectedLanguage,
        propertyPurpose: propertyPurposeOptions?.find(
          (item) => item['en'] == capitalizeFirstLetter(pathname)
        )?.[selectedLanguage],
        ...(apiFil ? apiFil : {})
      }
    });
  };

  const saveSearchData = {
    icon: (
      <Tooltip text={t('tabs.saveSearch')}>
        <IoBookmarkOutline size={20} color="var(--primary-clr)" />
      </Tooltip>
    ),
    text: t('tabs.saveSearch'),
    value: 'save search',
    id: '4'
  };

  const tabsData = isMobile
    ? [
        {
          icon: (
            <Tooltip text={t('tabs.map')}>
              <FaMapMarkedAlt size={22} color="var(--arrowColor)" />
            </Tooltip>
          ),

          value: 'map',
          // text: t('tabs.map'),
          tooltipText: t('tabs.map'),
          id: '3'
        }
        // , saveSearchData
      ]
    : [
        {
          icon: <BsGrid3X3GapFill size={20} color="var(--arrowColor)" />,

          tooltipText: t('tabs.grid'),
          value: 'grid',
          id: '1'
        },
        {
          icon: <BsListStars size={22} color="var(--arrowColor)" />,

          tooltipText: t('tabs.list'),
          value: 'list',
          id: '2'
        },
        {
          icon: <FaMapMarkedAlt size={22} color="var(--arrowColor)" />,
          value: 'map',

          tooltipText: t('tabs.map'),
          id: '3'
        }
      ];
  const [selectedTab, setSelectedTab] = useState(tabsData[1]);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  useEffect(() => {
    if (isMobile) {
      setSelectedTab({ text: t('tabs.list'), value: 'list', id: '2' });
    }
  }, [isMobile]);

  const getFilterModifyData = (fil) => {
    const filterData = {
      province: fil?.province?._id || fil?.province,
      town: fil?.town?._id || fil?.town,
      neighborhood: fil?.neighborhood?._id || fil?.neighborhood,
      nearby: !!fil?.nearby,
      ...(fil?.nearby || searchText || !!fil?.featuredLocation
        ? {
            lng: fil?.lng,
            lat: fil?.lat
          }
        : {}),
      minPrice: fil?.minPrice ? otherToUsd({ amount: fil?.minPrice, ...currency }) : '',
      maxPrice: fil?.maxPrice ? otherToUsd({ amount: fil?.maxPrice, ...currency }) : '',
      propertyPurpose: fil?.propertyPurpose,
      address: searchText,
      propertyStatus: propertyStatusFilterOptions?.find((a) => a?.en !== 'Any')
        ? fil?.propertyStatus?.[selectedLanguage]
        : '',
      propertyType:
        Array.isArray(fil?.entity) && fil?.entity.length > 0 && typeof fil?.entity[0] === 'object'
          ? fil?.entity.map((e) => e._id)
          : fil?.entity?._id || fil?.entity,
      minArea: fil?.minArea ? convertAreaIfNotInMeterSqaure(fil?.minArea, areaUnit) : '',
      maxArea: fil?.maxArea ? convertAreaIfNotInMeterSqaure(fil?.maxArea, areaUnit) : '',

      noOfRooms:
        Array.isArray(fil?.noOfRooms) && fil?.noOfRooms?.length > 0
          ? fil?.noOfRooms
              ?.filter((room) => {
                const roomValue =
                  typeof room === 'string' ? room : room?.[selectedLanguage] || room;
                return (
                  roomValue !== 'Any' &&
                  !(typeof room === 'object' && room?.en === 'Any') &&
                  !(typeof room === 'object' && room?.fr === 'Tout') &&
                  !(typeof room === 'object' && room?.ru === 'Любой') &&
                  !(typeof room === 'object' && room?.de === 'Beliebig') &&
                  !(typeof room === 'object' && room?.fa === 'هر چیز') &&
                  !(typeof room === 'object' && room?.tr === 'Herhangi') &&
                  !(typeof room === 'object' && room?.ar === 'أي')
                );
              })
              ?.map((room) => (typeof room === 'string' ? room : room?.[selectedLanguage] || room))
          : null,
      noOfBathrooms:
        Array.isArray(fil?.noOfBathrooms) && fil?.noOfBathrooms?.length > 0
          ? fil?.noOfBathrooms?.map((bathroom) => ({
              quantity: bathroom?.value || bathroom?.quantity || bathroom,
              more: bathroom?.more || false
            }))
          : null,

      lan: selectedLanguage,

      floorLevel:
        Array.isArray(fil?.floorLevel) && fil?.floorLevel.length > 0
          ? fil?.floorLevel.map((item) =>
              typeof item === 'object' && item[selectedLanguage] ? item[selectedLanguage] : item
            )
          : fil?.floorLevel &&
            typeof fil?.floorLevel === 'object' &&
            fil?.floorLevel[selectedLanguage]
          ? fil?.floorLevel[selectedLanguage]
          : fil?.floorLevel || null,
      parkingSpace: Array.isArray(fil?.parkingSpace)
        ? fil?.parkingSpace?.filter((item) => item?.quantity > 0)
        : fil?.parkingSpace &&
          fil?.parkingSpace?.quantity > 0 &&
          parkingSpaceFilterOptions?.findIndex(
            (a) => a?.[selectedLanguage] == fil?.parkingSpace?.[selectedLanguage]
          ) !== 0
        ? {
            quantity: Number(fil?.parkingSpace?.value),
            more: !!fil?.parkingSpace?.more
          }
        : (fil?.parkingSpace?.length > 0 &&
            parkingSpaceFilterOptions?.filter((a) =>
              fil?.parkingSpace?.map((e) => e?.quantity).includes(a?.value)
            )) ||
          '',
      rentType:
        Array.isArray(fil?.rentType) && fil?.rentType.length > 0
          ? fil?.rentType.map((item) =>
              typeof item === 'object' && item[selectedLanguage] ? item[selectedLanguage] : item
            )
          : fil?.rentType && typeof fil?.rentType === 'object' && fil?.rentType[selectedLanguage]
          ? fil?.rentType[selectedLanguage]
          : fil?.rentType || '',
      furniture:
        Array.isArray(fil?.furniture) && fil?.furniture.length > 0
          ? fil?.furniture.map((item) =>
              typeof item === 'object' && item[selectedLanguage] ? item[selectedLanguage] : item
            )
          : fil?.furniture && typeof fil?.furniture === 'object' && fil?.furniture[selectedLanguage]
          ? fil?.furniture[selectedLanguage]
          : fil?.furniture || '',
      propertyAge:
        Array.isArray(fil?.propertyAge) && fil?.propertyAge.length > 0
          ? fil?.propertyAge.map((item) =>
              typeof item === 'object' && item[selectedLanguage] ? item[selectedLanguage] : item
            )
          : fil?.propertyAge &&
            typeof fil?.propertyAge === 'object' &&
            fil?.propertyAge[selectedLanguage]
          ? fil?.propertyAge[selectedLanguage]
          : fil?.propertyAge || null,
      interiorAmenities: fil?.interiorAmenities?.map((e) => (typeof e === 'string' ? e : e?._id)),
      exteriorAmenities: fil?.exteriorAmenities?.map((e) => (typeof e === 'string' ? e : e?._id)),
      propertyClassification: fil?.propertyClassification?.[selectedLanguage]
    };

    if (searchText) {
      setFilters((prev) => ({
        ...prev,
        address: searchText
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        address: ''
      }));
    }

    return discardUndefinedOrNullValues(filterData);
  };

  const handleSearch = async (params) => {
    setPage(1);
    handleGetProperties(
      discardUndefinedOrNullValues({ ...getFilterModifyData(filters), ...params }),
      1
    );
  };

  const handleSaveSearch = async (title) => {
    const referenceObj = {
      title,
      province: filters?.province?._id,
      town: filters?.town?._id,
      neighborhood: filters?.neighborhood?._id,
      exteriorAmenities: filters?.exteriorAmenities?.map((a) => a?._id),
      interiorAmenities: filters?.interiorAmenities?.map((a) => a?._id),
      entity: filters?.entity?._id,

      propertyClassification: filters?.propertyClassification?.en.toLowerCase()
    };

    const filterData = {
      nearby: filters?.nearby,
      ...(filters?.nearby || searchText
        ? {
            lng: filters?.lng,
            lat: filters?.lat
          }
        : {}),
      address: searchText,
      propertyStatus: filters?.propertyStatus,
      minPrice: filters?.minPrice ? Number(filters?.minPrice) : '',
      maxPrice: filters?.maxPrice ? Number(filters?.maxPrice) : '',
      noOfRooms: filters?.noOfRooms,
      noOfBathrooms: filters?.noOfBathrooms,
      floorLevel: filters?.floorLevel,
      parkingSpace: filters?.parkingSpace,
      furniture: filters?.furniture,
      propertyAge: filters?.propertyAge,
      propertyPurpose: filters?.propertyPurpose,
      minArea: filters?.minArea ? convertAreaIfNotInMeterSqaure(filters?.minArea, areaUnit) : '',
      maxArea: filters?.maxArea ? convertAreaIfNotInMeterSqaure(filters?.maxArea, areaUnit) : '',
      country: filters?.country
    };

    const { ...validationData } = filterData;
    const ifFilterHasSelected = Object.keys(discardUndefinedOrNullValues(validationData));
    if (ifFilterHasSelected?.length === 0) {
      toast.warn(t('toast.noFilter'));
      return;
    }
    if (data?.data?.length === 0) {
      toast.warn(t('toast.noData'));
      return;
    }

    if (isLoading) {
      toast.warn(t('toast.loadingData'));
      return;
    }

    const submitData = discardUndefinedOrNullValues({
      data: discardUndefinedOrNullValues(filterData),
      ...referenceObj,
      type: 'property',
      pathName: window.location.pathname
    });

    setSaveSearchLoading(true);

    const response = await postApiFunc({
      url: `savedSearch`,
      method: 'POST',
      tag: `savedSearch`,
      data: submitData
    });

    if (response?.data) {
      toast.success(t('toast.successfully'));
      handleGetProperties();
    }

    setSaveSearchLoading(false);
    setShowSaveSearch(false);
  };

  useEffect(() => {
    if (isSavedFilter) {
      let newData = { ...isSavedFilter };
      delete newData?.address;
      setFilters((prev) => ({
        ...prev,
        ...newData,
        parkingSpace: Array.isArray(isSavedFilter?.parkingSpace)
          ? parkingSpaceFilterOptions?.filter((a) =>
              isSavedFilter?.parkingSpace?.map((e) => e?.quantity).includes(a?.value)
            )
          : [],
        furniture: furnitureFiltersOptions?.filter((a) =>
          isSavedFilter?.furniture?.includes(a[selectedLanguage])
        ),
        propertyAge: propertyAgeFilterOptions?.filter((a) =>
          isSavedFilter?.propertyAge?.includes(a[selectedLanguage])
        ),
        floorLevel: floorLevelFilterOptions?.filter((a) =>
          isSavedFilter?.floorLevel?.includes(a[selectedLanguage])
        ),
        noOfRooms:
          isSavedFilter?.noOfRooms?.length > 0 &&
          roomFilterOptions?.filter((a) => isSavedFilter?.noOfRooms.includes(a[selectedLanguage])),
        noOfBathrooms:
          isSavedFilter?.noOfBathrooms?.length > 0 &&
          bathRoomsFilterOptions?.filter((a) =>
            isSavedFilter?.noOfBathrooms?.some((obj) => obj?.quantity === a.value)
          ),
        propertyStatus: propertyStatusFilterOptions?.find(
          (a) => a[selectedLanguage] === isSavedFilter?.propertyStatus
        ),
        rentType:
          Array.isArray(isSavedFilter?.rentType) && isSavedFilter?.rentType.length > 0
            ? rentTypes.filter((obj) => isSavedFilter.rentType.includes(obj[selectedLanguage]))
            : []
      }));

      setSearchText(isSavedFilter?.address ?? '');

      //here issue
      handleGetProperties(
        discardUndefinedOrNullValues({
          ...getFilterModifyData({
            ...newData,
            noOfBathrooms:
              isSavedFilter?.noOfBathrooms?.length > 0 ? isSavedFilter?.noOfBathrooms : null,
            propertyStatus:
              isSavedFilter?.propertyStatus?.[selectedLanguage] || isSavedFilter?.propertyStatus,
            noOfRooms: isSavedFilter?.noOfRooms,
            floorLevel: isSavedFilter?.floorLevel,
            parkingSpace:
              isSavedFilter?.parkingSpace?.[selectedLanguage] || isSavedFilter?.parkingSpace,
            furniture: isSavedFilter?.furniture?.[selectedLanguage] || isSavedFilter?.furniture,
            propertyAge:
              isSavedFilter?.propertyAge?.[selectedLanguage] || isSavedFilter?.propertyAge,
            address: isSavedFilter?.address,
            province: isSavedFilter?.province?._id,
            town: isSavedFilter?.town?._id,
            neighborhood: isSavedFilter?.neighborhood?._id,
            exteriorAmenities: isSavedFilter?.exteriorAmenities?.map((a) => a?._id),
            interiorAmenities: isSavedFilter?.interiorAmenities?.map((a) => a?._id),
            propertyType: isSavedFilter?.entity?._id,
            rentType: isSavedFilter?.rentType
          })
        }),
        page
      );
    }
  }, [isSavedFilter]);

  useEffect(() => {
    if (isSavedFilter) return;

    const params = new URLSearchParams(window.location.search);

    if ([...params.keys()].length > 0) {
      const urlFilters = searchParamsToFilters(params);
      setFilters((prev) => ({
        ...prev,
        minPrice: urlFilters?.minPrice,
        maxPrice: urlFilters?.maxPrice,
        minArea: urlFilters?.minArea,
        maxArea: urlFilters?.maxArea,
        entity: urlFilters?.propertyType,
        parkingSpace: parkingSpaceFilterOptions?.filter((a) =>
          urlFilters?.parkingSpace?.map((e) => e?.quantity).includes(a.value)
        ),
        furniture: furnitureFiltersOptions.filter((a) =>
          urlFilters?.furniture?.includes(a[selectedLanguage])
        ),
        propertyAge: propertyAgeFilterOptions.filter((a) =>
          urlFilters?.propertyAge?.includes(a[selectedLanguage])
        ),
        floorLevel: floorLevelFilterOptions.filter((a) =>
          urlFilters?.floorLevel?.includes(a[selectedLanguage])
        ),

        noOfRooms: urlFilters?.noOfRooms,
        noOfBathrooms:
          urlFilters?.noOfBathrooms?.length > 0 &&
          bathRoomsFilterOptions?.filter((a) =>
            urlFilters?.noOfBathrooms?.some((obj) => obj?.quantity === a.value)
          ),
        propertyStatus: propertyStatusFilterOptions.find(
          (a) => a[selectedLanguage] === urlFilters?.propertyStatus
        ),

        rentType:
          Array.isArray(urlFilters?.rentType) && urlFilters?.rentType.length > 0
            ? rentTypes.filter((obj) => urlFilters.rentType.includes(obj[selectedLanguage]))
            : [],
        exteriorAmenities: exteriorAmenities?.filter((a) => {
          if (Array.isArray(urlFilters?.exteriorAmenities)) {
            return urlFilters?.exteriorAmenities?.includes(a?._id);
          } else if (typeof urlFilters?.exteriorAmenities === 'string') {
            return a?._id === urlFilters?.exteriorAmenities;
          }
          return false;
        }),

        interiorAmenities: interiorAmenities?.filter((a) => {
          if (Array.isArray(urlFilters?.interiorAmenities)) {
            return urlFilters?.interiorAmenities?.includes(a?._id);
          } else if (typeof urlFilters?.interiorAmenities === 'string') {
            return a?._id === urlFilters?.interiorAmenities;
          }
          return false;
        }),
        // neighborhood
        // :
        // "685e5c14ad962f001c652645"
        // propertyPurpose
        // :
        // "Buy"
        // province
        // :
        // "66c3bc2f04cc92001c6b144b"
        // town
        // :
        // "66c3bd8d04cc92001c6b1503"
        province: urlFilters?.province,
        town: urlFilters?.town,
        neighborhood: urlFilters?.neighborhood
      }));

      if (urlFilters?.address) {
        setSearchText(
          Array.isArray(urlFilters?.address)
            ? urlFilters?.address?.join(',').trim()
            : urlFilters?.address?.trim()
        );
      }

      setTimeout(() => {
        handleGetProperties(urlFilters, 1);
      }, 0);
    } else {
      handleGetProperties();
    }
  }, [exteriorAmenities]);

  // sticky filter
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 5) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <style>
        {`
        .gm-style-iw-c {
        max-width: 310px !important;
        }
        @media (max-width: 991px){
       .gm-style .gm-style-iw-d {
        max-height: 420px !important;
        }

        
        }

         @media (max-width: 768px){
       .gm-style .gm-style-iw-c {
        max-height: 480px !important;
        }

        
        }

        @media (max-width: 400px){
         .gm-style-iw-c {
        max-width: 245px !important;
        }
        }
        `}
      </style>
      <div className={classes.page}>
        <Header containerClass="" />
        <div className={[classes.filtersDiv, isSticky && classes.sticky].join(' ')}>
          <BuyRentCommercialFilters
            containerClass=""
            filtersWrapperClass={classes.filters}
            rowClass={classes.filtersRow}
            filters={filters}
            setFilters={setFilters}
            t={t}
            searchText={searchText}
            setSearchText={setSearchText}
            onSearch={handleSearch}
            savedSearch={isSavedFilter}
          />
        </div>

        <Container fluid={selectedTab?.value === 'map'}>
          <Row className={classes.mainRow}>
            <Col md={5} className={classes.dataLeftStrip}>
              <BreadCrumb
                data={[
                  {
                    title: 'Home',
                    path: '/'
                  },
                  {
                    title: capitalizeFirstLetter(pathname),
                    // path: `/${pathname}`,
                    active: true
                  }
                ]}
              />
              <p className={classes.tabsDiv__highlight2}>
                {`${filters?.propertyClassification[selectedLanguage]} ${
                  filters?.propertyText[selectedLanguage]
                }  ${t('for')} ${
                  purpose === 'buy' ? buyLangObj[selectedLanguage] : rentLangObj[selectedLanguage]
                }  ${
                  filters?.address
                    ? `${t('in')} ${filters?.address}`
                    : `${t('in')} ${
                        getValue(filters?.neighborhood?.name?.[selectedLanguage], ',') || '' // data?.data?.[0]?.neighborhood?.name?.[selectedLanguage]
                      } ${getValue(filters?.town?.name?.[selectedLanguage])}`
                }`}
                {data?.totalRecords ?? 0} {t('title')}
              </p>
            </Col>
            <Col md={7}>
              <div className={classes?.dataStripRight}>
                <DropDown
                  borderRadius="35px"
                  className={classes?.dropdown}
                  classNamePrefix={'smDropdown'}
                  options={propertyFilterOptions}
                  value={propertyFilterOptions.find((option) => option.value === filters.sortType)}
                  setValue={(e) => {
                    setFilters((prevFilters) => ({
                      ...prevFilters,
                      sortType: e?.value
                    }));
                    setPage(1);
                    handleGetProperties({ ...getFilterModifyData(filters), sortType: e?.value }, 1);
                  }}
                  optionLabel={[selectedLanguage]}
                  optionValue={'value'}
                  placeholder={t('sortBy')}
                  customStyle={{
                    height: '44px',
                    fontSize: '14px'
                  }}
                />
                <Button
                  borderRadius="50px"
                  label={saveSearchData.text}
                  leftIcon={saveSearchData.icon}
                  variant="white"
                  onClick={() => {
                    if (!restrictOnlyUserActions(user?.role)) return;
                    if (!isLogin) return toast.warn('Please login first to save your search');
                    return setShowSaveSearch(true);
                  }}
                  className={classes.saveButton}
                />
                <Tabs
                  separatorColor="var(--white-clr)"
                  tabClass={classes.tab}
                  setValue={(e) => {
                    if (isMobile && e?.value === selectedTab?.value) {
                      setSelectedTab({ value: 'list' });
                    } else {
                      setSelectedTab(e);
                    }
                  }}
                  value={selectedTab}
                  tabsData={tabsData}
                />
              </div>
            </Col>
            <Col
              md={selectedTab?.value == 'map' ? 12 : 10}
              className={[
                selectedTab?.value !== 'map' && 'verticalBannerAndContentWidth',
                classes.col1
              ].join(' ')}>
              {isLoading ? (
                <Loader />
              ) : (
                <Row
                  className={[classes.innerRow, selectedTab?.value == 'map' && classes.h100].join(
                    ' '
                  )}>
                  {/* --------------------- MAP View Start ----------------------- */}
                  {selectedTab?.value == 'map' ? (
                    <>
                      <Col
                        xl={{ span: 5, order: 1 }}
                        xs={{ span: 12, order: 2 }}
                        className={`scroller ${classes.mapLisingCards}`}>
                        <Row className={classes.mapList}>
                          {mapProperties?.map((e, key) => (
                            <Col xl={6} lg={4} sm={6} key={key}>
                              <PropertyCard
                                feature
                                data={e}
                                onEmailClick={() => {
                                  setIsModalOpen('email');
                                  setSelectedItem(e);
                                }}
                                refetch={handleGetProperties}
                              />
                            </Col>
                          ))}
                        </Row>
                      </Col>
                      <Col xl={{ span: 7, order: 2 }} xs={{ span: 12, order: 1 }}>
                        <MapMain
                          showLandMarks={false}
                          className={classes.mainMap}
                          mapClass={classes?.mapClass}
                          zoom={5.5}
                          mapProperties={data?.data}
                          setMapProperties={setMapProperties}
                          showMarker={false}
                        />
                      </Col>
                      {/* --------------------- MAP View End ----------------------- */}
                    </>
                  ) : data?.data?.length == 0 ? (
                    <NoData text={t('noDataText')} />
                  ) : (
                    data?.data?.map((item, key) => (
                      <>
                        <Col
                          md={selectedTab?.value == 'list' ? 12 : 6}
                          lg={selectedTab?.value == 'list' ? 12 : 4}
                          sm={selectedTab?.value == 'list' ? 12 : 6}
                          xs={12}
                          key={key}>
                          {selectedTab?.value == 'list' ? (
                            <PropertyHorizontalCard
                              data={item}
                              index={key}
                              className="mb-0"
                              onEmailClick={() => {
                                setIsModalOpen('email');
                                setSelectedItem(item);
                              }}
                              refetch={handleGetProperties}
                            />
                          ) : (
                            <PropertyCard
                              feature
                              data={item}
                              index={key}
                              onEmailClick={() => {
                                setIsModalOpen('email');
                                setSelectedItem(item);
                              }}
                              refetch={handleGetProperties}

                              // setPropertyData={setPropertyData}
                            />
                          )}
                        </Col>
                        {
                          // selectedTab?.value === 'list' &&
                          horizontalBanners?.length > 0 &&
                            bannerConditions[selectedTab?.value].renderCondition(key) && (
                              <Col md={12}>
                                <div className={classes?.bannerAdContainer}>
                                  <BannerImageAd
                                    className={classes.horizontalBanner}
                                    image={imageUrl(
                                      horizontalBanners[
                                        bannerConditions.renderContentCondition(key)
                                      ].image
                                    )}
                                    link={
                                      horizontalBanners[
                                        bannerConditions.renderContentCondition(key)
                                      ]?.link
                                    }
                                  />
                                </div>
                              </Col>
                            )
                        }
                      </>
                    ))
                  )}
                  {['list', 'grid'].includes(selectedTab?.value) && data?.data?.length > 0 && (
                    <Col md={12} className={[classes.pagination, 'jCenter'].join(' ')}>
                      <PaginationComponent
                        totalPages={Math.ceil(data?.totalRecords / recordsLimit15)}
                        currentPage={page}
                        setCurrentPage={(e) => {
                          setPage(e);
                          handleGetProperties(getFilterModifyData(filters), e);
                        }}
                      />
                    </Col>
                  )}
                </Row>
              )}
            </Col>

            <Col
              lg={2}
              className={[
                selectedTab?.value == 'map' && 'd-none',
                'verticalBannerWidth',
                classes.col2
              ].join(' ')}>
              <Row className={`${classes.bannerRow}`} data-margin={selectedTab?.value == 'map'}>
                {verticalBanners?.map((item, key) => (
                  <Col
                    md={12}
                    className={key == 1 && classes?.bannerCol}
                    key={`${item?._id}-${key}`}>
                    <BannerImageAd
                      image={imageUrl(item?.image)}
                      link={item?.link}
                      className={classes.verticalBanner}
                    />
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
        {isModalOpen == 'email' && (
          <EmailAgentModal
            show={isModalOpen == 'email'}
            setShow={setIsModalOpen}
            data={selectedItem}
            type={'property'}
            inquiryType={'inquiry'}
          />
        )}
      </div>
      <Footer />

      {showSaveSearch && (
        <SaveSearchModal
          show
          t={t}
          setShow={setShowSaveSearch}
          onClick={(title) => handleSaveSearch(title)}
          loading={saveSearchLoading}
        />
      )}
    </>
  );
}

export default Properties;

Properties.propTypes = {
  purpose: PropTypes.string
};
